<template>
    <b-modal
        v-model="isVisible"
        :id="'profile-add-card-modal'"
        :ref="'profile-add-card-modal'"
        :title="$t('profile.new_timeline_item')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        size="lg"
        @ok="onOk"
        :ok-disabled="disabled"
        modal-class="apprentice-default-modal add-profile-card-modal"
        :no-enforce-focus="true">
        <div class="add-profile-card">
            <div class="inputs-combined">
                <b-form-group
                    class="profile-card-title-group"
                    :label="$t('common.title')"
                    label-for="profile-card-title">
                    <b-form-input
                        id="profile-card-title"
                        v-model="title"
                        :placeholder="$t('profile.enter_a_title')"></b-form-input>
                </b-form-group>

                <b-form-group
                    class="profile-card-category-group"
                    :label="$t('profile.category')"
                    label-for="profile-card-category">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="profile-card-category"
                        v-model="selectedCategory"
                        value-field="id"
                        text-field="title"
                        :options="categories">
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    class="profile-card-date-group"
                    label="Datum"
                    label-for="profile-card-date">
                    <b-form-datepicker
                        class="apprentice-date-picker"
                        id="profile-card-date"
                        v-model="date"
                        :config="datepickerOptionsDate"
                        start-weekday="1"
                        locale="nl"
                        now-button
                        reset-button
                        right
                        today-variant="primary"
                        nav-button-variant="primary"
                        :aria-controls="$t('profile.choose_date')"
                        label-reset-button="Reset"
                        :max="getMaxDate()"
                        :label-no-date-selected="$t('profile.choose_date')"
                        menu-class="datedropdown">
                    </b-form-datepicker>
                </b-form-group>
            </div>

            <div
                class="category-description"
                v-if="categoryDescription">
                <b-form-group
                    class="profile-card-category-description-group"
                    :label="$t('profile.category_description')"
                    label-for="profile-card-category-description">
                    <design-2021-apprentice-display-html-component
                        class="explanation-text explanation-type"
                        :html-content="categoryDescription"></design-2021-apprentice-display-html-component>
                </b-form-group>
            </div>

            <b-form-group
                class="profile-card-description-group"
                :label="$t('common.description')"
                label-for="profile-card-description">
                <ckeditor
                    id="profile-card-description"
                    v-model="description"
                    @ready="onReady"
                    :editor="editor"
                    :config="editorConfig"></ckeditor>
            </b-form-group>

            <div class="profile-card-media-files">
                <div class="profile-card-add-files">
                    <p class="info label">{{ $t('common.add_files') }}</p>
                    <b-button
                        class="btn-upload btn-file-upload"
                        variant="primary"
                        @click="$refs.fileUpload.$el.childNodes[0].click()">
                        {{ $t('profile.select_files') }}
                    </b-button>
                    <b-form-file
                        v-show="false"
                        v-on:change="addFiles"
                        ref="fileUpload"
                        multiple></b-form-file>
                </div>

                <div class="profile-card-add-video-link">
                    <p class="info label">{{ $t('profile.add_youtube_link') }}</p>
                    <b-input-group class="video-link-group">
                        <b-form-input
                            v-model="url"
                            size="lg"
                            placeholder="Vul een url in"></b-form-input>
                        <b-input-group-append>
                            <b-button
                                class="btn-add btn-add-profile-card"
                                variant="primary"
                                @click="addLink">
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>

            <div
                class="profile-card-media-table"
                v-if="items.length">
                <h5 class="title">{{ $t('profile.attachments') }}</h5>
                <design-2021-apprentice-data-table
                    class="attachments-table"
                    :fields="fields"
                    :items="items"
                    nosearch>
                    <template #cell(media_file)="row">
                        <div class="title">
                            {{ row.item.media_file }}
                        </div>
                    </template>
                    <template #cell(type)="row">
                        <design-2021-apprentice-display-html-component
                            class="profile-card-media-table-type"
                            :html-content="getMediaType(row)">
                        </design-2021-apprentice-display-html-component>
                    </template>
                    <template #cell(actions)="row">
                        <b-button
                            class="btn-remove profile-card-media-remove"
                            variant="danger-icon-only"
                            @click="removeMedia(row)">
                        </b-button>
                    </template>
                </design-2021-apprentice-data-table>
            </div>
        </div>
    </b-modal>
</template>

<script>
import moment from 'moment';
import ApprenticeEditor from '../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-profile-add-card-component',
    props: ['categoriesIn', 'seasonsIn'],
    data() {
        return {
            card: null,
            title: null,
            description: '',
            categories: [
                {
                    id: null,
                    title: this.$t('profile.choose_category'),
                    disabled: true,
                },
                ...this.categoriesIn,
            ],
            selectedCategory: null,
            date: null,
            datepickerOptionsDate: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            },
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                placeholder: this.$t('common.description'),
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'imageUpload',
                        'blockQuote',
                        'insertTable',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            file: null,
            url: null,
            fields: [
                {
                    key: 'media_files',
                    label: this.$t('common.file'),
                },
                {
                    key: 'type',
                    label: 'Type',
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            attachments: [],
            isVisible: false,
        };
    },
    computed: {
        categoryDescription() {
            for (let category of this.categoriesIn) {
                if (category.id === this.selectedCategory) {
                    if (category.description) {
                        return category.description;
                    }
                }
            }

            return null;
        },

        disabled() {
            return !this.title || !this.selectedCategory || !this.description || !this.date;
        },

        items() {
            if (this.attachments.length >= 1) {
                return this.attachments.map((file) => {
                    if (file.type === 'link') {
                        return {
                            media_files: file.path,
                            type: file.type,
                        };
                    } else {
                        return {
                            media_files: file.file.name,
                            type: file.file.type === 'audio/mpeg' ? 'mp3' : file.file.type.split('/').slice(-1)[0],
                        };
                    }
                });
            }

            return [];
        },
    },

    methods: {
        onOk() {
            const mediaLinks = this.attachments.filter((file) => file.type === 'link');
            const mediaFile = this.attachments.filter((file) => file.type === 'file');

            let data = new FormData();
            data.append('title', this.title);
            data.append('description', this.description);
            data.append('category_id', this.selectedCategory);
            data.append('date', moment(this.date).format('DD-MM-YYYY'));

            let count = 0;
            for (const file of mediaFile) {
                if (file.file.hasOwnProperty('id')) {
                    data.append('newStoredFileIds[' + count + ']', file.file.id);
                } else {
                    data.append('newFiles[' + count + ']', file.file);
                }
                count++;
            }

            count = 0;
            for (const link of mediaLinks) {
                data.append('media_links[' + count + ']', link.path);
                count++;
            }
            const headers = { 'Content-Type': 'multipart/form-data' };

            this.$emit('add-card', data, headers);

            this.title = null;
            this.description = '';
            this.selectedCategory = null;
            this.date = null;
            this.url = '';
            this.attachments = [];
        },

        show(card) {
            if (card) {
                this.title = card.title;
                this.description = card.description;
                this.selectedCategory = null;
                this.date = card.date;
                this.url = '';
                this.attachments = card.attachments;
            } else {
                this.title = null;
                this.description = '';
                this.selectedCategory = null;
                this.date = null;
                this.url = '';
                this.attachments = [];
            }

            this.isVisible = true;
        },

        addFiles() {
            const files = this.$refs.fileUpload.$el.childNodes[0].files;

            for (const file of files) {
                this.attachments.push({ type: 'file', file });
            }
        },

        addLink() {
            if (!this.url) {
                return;
            }

            this.attachments.push({
                path: this.url,
                type: 'link',
            });

            this.url = '';
        },

        getMediaType(media) {
            const imageTypes = [
                'jpg',
                'JPG',
                'jpeg',
                'JPEG',
                'png',
                'PNG',
                'gif',
                'GIF',
                'tiff',
                'TIFF',
                'bmp',
                'BMP',
                'jif',
                'jfif',
            ];
            const videoTypes = ['mp4', 'mov', 'avi', 'webm', 'wmv', 'mkv', 'ogg', 'vob', 'mpeg', '3gp', 'mpeg'];

            if (videoTypes.includes(media.item.type)) {
                return `<span class="icon text-primary btn-video-icon"></span>Videobestand`;
            } else if (media.item.type === 'link') {
                return `<span class="icon text-primary btn-youtube-icon"></span>Video link`;
            } else if (imageTypes.includes(media.item.type)) {
                return `<span class="icon text-primary btn-image-icon"></span>Afbeelding`;
            } else if (media.item.type === 'mp3') {
                return `<span class="icon text-primary btn-audio-icon"></span>Audiobestand`;
            } else {
                return `<span class="icon text-primary btn-file-icon"></span>Bestand`;
            }
        },

        removeMedia(media) {
            this.attachments = this.attachments.filter((file) => {
                if (file.type === 'link') {
                    return file.path !== media.item.media_files;
                } else {
                    return file.name !== media.item.media_files;
                }
            });
        },
        getMaxDate() {
            if (this.seasonsIn.length >= 1) {
                const maxSeason = this.seasonsIn[0].season.split('-');
                return new Date(maxSeason[1], 7, 0);
            }
        },

        onReady() {
            const wrapper = document.querySelector('.ck-body-wrapper');
            wrapper.remove();
            const editor = document.querySelector('.ck-editor');
            editor.appendChild(wrapper);
        },
    },
};
</script>

<style scoped lang="scss">
.inputs-combined {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .form-control,
    .form-group,
    .apprentice-primary-select {
        margin-bottom: 0;
    }

    > div:not(:last-child) {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.profile-card-add-files .btn,
.profile-card-add-video-link .btn {
    width: 100%;
}

.profile-card-add-files {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.profile-card-media-table ::v-deep {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }

    .apprentice-simple-card {
        padding: 0;
    }

    .apprentice-table-header {
        display: none;
    }
}

.profile-card-media-table-type {
    display: flex;
    align-items: center;
}

.profile-card-description-group,
.profile-card-media-files {
    margin-bottom: $grid-gutter-width;
}

.category-description {
    margin-bottom: $grid-gutter-width;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .profile-card-add-files .btn,
    .profile-card-add-video-link .btn {
        width: auto;
    }

    .attachments-table ::v-deep {
        table tbody tr td:first-child {
            width: 65%;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .inputs-combined,
    .profile-card-media-files {
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: baseline;

        > div {
            flex: 1;

            &:not(:last-child) {
                margin-right: $grid-gutter-width;
            }
        }
    }

    .profile-card-media-files {
        .profile-card-add-files {
            flex: 0 0 auto;
            margin-bottom: 0;
        }
    }

    .profile-card-add-video-link {
        display: flex;
        flex-direction: column;
        align-content: center;
        flex-grow: 1;
    }

    .video-link-group {
        input {
            margin-bottom: 0;
        }

        .btn-add-profile-card {
            &:before {
                margin-right: 0;
            }
        }
    }

    .btn-file-upload {
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .add-profile-card-modal .modal-lg {
        width: 930px;
    }
}
</style>
